import { customEventFactory } from './events';

export enum LicenseLimitationErrorTypes {
	createProject = 'error.license.createProject',
	copyProject = 'error.license.copyProject',
	transferProject = 'error.license.transferProject', // can be used for both copyProject and transferProject
	collaboratorShareProject = 'error.license.shareProject.collaborator',
	createEntry = 'error.license.createEntry',
	collaboratorCreateEntry = 'error.license.createEntry.collaborator'
}

export const toggleFreeLicenseLimitationModalEvent = () =>
	customEventFactory<LicenseLimitationErrorTypes>('toggle-free-license-limitation-modal');
